var React = require('react');

module.exports = React.createClass({
  render: function() {
    var baseProps = {
      'width': '20px',
'height': '10px',
'viewBox': '0 0 20 10',
'version': '1.1',
'xmlns': 'http://www.w3.org/2000/svg',
'xmlnsXlink': 'http://www.w3.org/1999/xlink',
      className: 'svg-icon',
      dangerouslySetInnerHTML: {
        __html: " <!-- Generator: Sketch 45.2 (43514) - http://www.bohemiancoding.com/sketch --> <title>slow</title> <desc>Created with Sketch.</desc> <defs></defs> <g id=\"CANDIDATE-VIEW\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"> <g id=\"Post-Assessment-1-Report\" transform=\"translate(-771.000000, -3133.000000)\" fill=\"#FD0000\"> <g id=\"Body-Segment\" transform=\"translate(180.000000, 192.000000)\"> <g id=\"Section-2\" transform=\"translate(0.000000, 2234.000000)\"> <g id=\"Problem-1\" transform=\"translate(58.000000, 612.000000)\"> <g id=\"speed\" transform=\"translate(533.000000, 56.000000)\"> <polygon id=\"slow\" points=\"0 39 9.64381561 48.6438156 19.2876312 39\"></polygon> </g> </g> </g> </g> </g> </g> ",
      }
    };
    var props = Object.assign({}, baseProps, this.props);
    return React.createElement('svg', props);
  },
});



// WEBPACK FOOTER //
// ./node_modules/dk-ui-lib/assets/slow.svg